'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PortalIdParser from 'PortalIdParser';
import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DowngradeActionDisabledTooltip = ({
  action
}) => /*#__PURE__*/_jsxs("div", {
  className: "action-tooltip-content",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `EmailComponents.classicTemplateDowngrade.${action}`
    })
  }), /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: `/browse/${PortalIdParser.get()}/compare/marketing?product=pro`,
    use: "on-dark",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.classicTemplateDowngrade.upgradeLearnMoreLink"
    })
  })]
});
DowngradeActionDisabledTooltip.propTypes = {
  action: PropTypes.string
};
export default DowngradeActionDisabledTooltip;